import React from "react";

const LanguageContext = React.createContext("fr");

export default LanguageContext;
